module.exports = __webpack_public_path__ + "static/media/bindQQ2.54b6555c.png";